var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful-module-spacing.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
["moduleEntry", "moduleIndex", "moduleCount", "isLastInLoop"], 
["isSpecialtyShop", "containsProductGrid", "isFlex", "isGiveaway"], 
function (l_moduleEntry, l_moduleIndex, l_moduleCount, l_isLastInLoop, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("moduleEntry", l_moduleEntry);
frame.set("moduleIndex", l_moduleIndex);
frame.set("moduleCount", l_moduleCount);
frame.set("isLastInLoop", l_isLastInLoop);
frame.set("isSpecialtyShop", kwargs.hasOwnProperty("isSpecialtyShop") ? kwargs["isSpecialtyShop"] : false);
frame.set("containsProductGrid", kwargs.hasOwnProperty("containsProductGrid") ? kwargs["containsProductGrid"] : false);
frame.set("isFlex", kwargs.hasOwnProperty("isFlex") ? kwargs["isFlex"] : false);
frame.set("isGiveaway", kwargs.hasOwnProperty("isGiveaway") ? kwargs["isGiveaway"] : false);
var t_2 = "";var t_3;
t_3 = env.getFilter("trim").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((l_moduleEntry),"fields")),"topMargin"),""));
frame.set("topMargin", t_3, true);
if(frame.topLevel) {
context.setVariable("topMargin", t_3);
}
if(frame.topLevel) {
context.addExport("topMargin", t_3);
}
var t_4;
t_4 = env.getFilter("trim").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((l_moduleEntry),"fields")),"bottomMargin"),""));
frame.set("bottomMargin", t_4, true);
if(frame.topLevel) {
context.setVariable("bottomMargin", t_4);
}
if(frame.topLevel) {
context.addExport("bottomMargin", t_4);
}
var t_5;
t_5 = (lineno = 5, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [l_moduleEntry,"fields.smallScreenDisplay","row"]));
frame.set("smallScreenDisplay", t_5, true);
if(frame.topLevel) {
context.setVariable("smallScreenDisplay", t_5);
}
if(frame.topLevel) {
context.addExport("smallScreenDisplay", t_5);
}
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((l_moduleEntry),"fields")),"stackedOnSmallScreen") || runtime.contextOrFrameLookup(context, frame, "smallScreenDisplay") == "stacked";
frame.set("stackedOnSmallScreen", t_6, true);
if(frame.topLevel) {
context.setVariable("stackedOnSmallScreen", t_6);
}
if(frame.topLevel) {
context.addExport("stackedOnSmallScreen", t_6);
}
var t_7;
t_7 = runtime.contextOrFrameLookup(context, frame, "smallScreenDisplay") == "slider";
frame.set("isMobileSlider", t_7, true);
if(frame.topLevel) {
context.setVariable("isMobileSlider", t_7);
}
if(frame.topLevel) {
context.addExport("isMobileSlider", t_7);
}
var t_8;
t_8 = runtime.memberLookup((runtime.memberLookup((l_moduleEntry),"fields")),"stackedOnMediumScreen");
frame.set("stackedOnMediumScreen", t_8, true);
if(frame.topLevel) {
context.setVariable("stackedOnMediumScreen", t_8);
}
if(frame.topLevel) {
context.addExport("stackedOnMediumScreen", t_8);
}
var t_9;
t_9 = (env.getFilter("trim").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((l_moduleEntry),"fields")),"moduleSplit"),"")));
frame.set("moduleSplit", t_9, true);
if(frame.topLevel) {
context.setVariable("moduleSplit", t_9);
}
if(frame.topLevel) {
context.addExport("moduleSplit", t_9);
}
var t_10;
t_10 = runtime.memberLookup((runtime.memberLookup((l_moduleEntry),"fields")),"includeGutters");
frame.set("includeGutters", t_10, true);
if(frame.topLevel) {
context.setVariable("includeGutters", t_10);
}
if(frame.topLevel) {
context.addExport("includeGutters", t_10);
}
var t_11;
t_11 = (!((runtime.contextOrFrameLookup(context, frame, "containsProductGrid") && l_moduleCount > 1) || runtime.contextOrFrameLookup(context, frame, "isFlex") || runtime.contextOrFrameLookup(context, frame, "isMobileSlider"))?true:false);
frame.set("shouldRenderBottomMargins", t_11, true);
if(frame.topLevel) {
context.setVariable("shouldRenderBottomMargins", t_11);
}
if(frame.topLevel) {
context.addExport("shouldRenderBottomMargins", t_11);
}
t_2 += "\n    ";
t_2 += runtime.suppressValue(env.getFilter("trim").call(context, ((env.getFilter("trim").call(context, (lineno = 12, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "calculateScreenSize"), "calculateScreenSize", context, [l_moduleEntry])))) + "" + " " + "" + (env.getFilter("trim").call(context, (lineno = 13, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "calculateModuleSplit"), "calculateModuleSplit", context, [runtime.contextOrFrameLookup(context, frame, "moduleSplit"),l_moduleIndex,l_moduleCount,runtime.contextOrFrameLookup(context, frame, "stackedOnSmallScreen"),runtime.contextOrFrameLookup(context, frame, "stackedOnMediumScreen"),runtime.contextOrFrameLookup(context, frame, "isMobileSlider"),runtime.contextOrFrameLookup(context, frame, "isGiveaway")])))) + "" + " " + "" + (env.getFilter("trim").call(context, runtime.contextOrFrameLookup(context, frame, "topMargin"))) + "" + " " + "" + (env.getFilter("trim").call(context, (lineno = 15, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "setGutters"), "setGutters", context, [runtime.contextOrFrameLookup(context, frame, "includeGutters")])))))) + "" + ((runtime.contextOrFrameLookup(context, frame, "shouldRenderBottomMargins")?(lineno = 16, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "getBottomMarginClasses"), "getBottomMarginClasses", context, [l_moduleEntry,l_isLastInLoop,runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop")])):"")) + "" + " ", env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_2);
});
context.addExport("calculateModuleSpacing");
context.setVariable("calculateModuleSpacing", macro_t_1);
output += "\n\n\n";
var macro_t_12 = runtime.makeMacro(
["includeGutters"], 
[], 
function (l_includeGutters, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("includeGutters", l_includeGutters);
var t_13 = "";if(l_includeGutters == false) {
t_13 += "\n        u-no-gutters\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
context.addExport("setGutters");
context.setVariable("setGutters", macro_t_12);
output += "\n\n\n";
var macro_t_14 = runtime.makeMacro(
["moduleSplit", "moduleIndex", "moduleCount"], 
["stackedOnSmallScreen", "stackedOnMediumScreen", "isMobileSlider", "isGiveaway"], 
function (l_moduleSplit, l_moduleIndex, l_moduleCount, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("moduleSplit", l_moduleSplit);
frame.set("moduleIndex", l_moduleIndex);
frame.set("moduleCount", l_moduleCount);
frame.set("stackedOnSmallScreen", kwargs.hasOwnProperty("stackedOnSmallScreen") ? kwargs["stackedOnSmallScreen"] : false);
frame.set("stackedOnMediumScreen", kwargs.hasOwnProperty("stackedOnMediumScreen") ? kwargs["stackedOnMediumScreen"] : false);
frame.set("isMobileSlider", kwargs.hasOwnProperty("isMobileSlider") ? kwargs["isMobileSlider"] : false);
frame.set("isGiveaway", kwargs.hasOwnProperty("isGiveaway") ? kwargs["isGiveaway"] : false);
var t_15 = "";var t_16;
t_16 = 12;
frame.set("columnWidth", t_16, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_16);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_16);
}
t_15 += "\n    ";
var t_17;
t_17 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("customClass", t_17, true);
if(frame.topLevel) {
context.setVariable("customClass", t_17);
}
if(frame.topLevel) {
context.addExport("customClass", t_17);
}
t_15 += "\n\n    ";
if(l_moduleCount == 2) {
if(l_moduleSplit == "50-50") {
var t_18;
t_18 = (env.getFilter("int").call(context, (12 * 0.5)));
frame.set("columnWidth", t_18, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_18);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_18);
}
;
}
else {
if(l_moduleSplit == "40-60") {
if(l_moduleIndex == 1) {
t_15 += "\n                ";
var t_19;
t_19 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.4))));
frame.set("columnWidth", t_19, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_19);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_19);
}
t_15 += "\n            ";
;
}
else {
if(l_moduleIndex == 2) {
t_15 += "\n                ";
var t_20;
t_20 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.6))));
frame.set("columnWidth", t_20, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_20);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_20);
}
t_15 += "\n            ";
;
}
;
}
;
}
else {
if(l_moduleSplit == "60-40") {
if(l_moduleIndex == 1) {
t_15 += "\n                ";
var t_21;
t_21 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.6))));
frame.set("columnWidth", t_21, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_21);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_21);
}
t_15 += "\n            ";
;
}
else {
if(l_moduleIndex == 2) {
t_15 += "\n                ";
var t_22;
t_22 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.4))));
frame.set("columnWidth", t_22, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_22);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_22);
}
t_15 += "\n            ";
;
}
;
}
;
}
else {
if(l_moduleSplit == "30-70") {
if(l_moduleIndex == 1) {
t_15 += "\n                ";
var t_23;
t_23 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.3))));
frame.set("columnWidth", t_23, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_23);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_23);
}
t_15 += "\n            ";
;
}
else {
if(l_moduleIndex == 2) {
t_15 += "\n                ";
var t_24;
t_24 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.7))));
frame.set("columnWidth", t_24, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_24);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_24);
}
t_15 += "\n            ";
;
}
;
}
;
}
else {
if(l_moduleSplit == "70-30") {
if(l_moduleIndex == 1) {
t_15 += "\n                ";
var t_25;
t_25 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.7))));
frame.set("columnWidth", t_25, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_25);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_25);
}
t_15 += "\n            ";
;
}
else {
if(l_moduleIndex == 2) {
t_15 += "\n                ";
var t_26;
t_26 = (env.getFilter("int").call(context, env.getFilter("round").call(context, (12 * 0.3))));
frame.set("columnWidth", t_26, true);
if(frame.topLevel) {
context.setVariable("columnWidth", t_26);
}
if(frame.topLevel) {
context.addExport("columnWidth", t_26);
}
t_15 += "\n            ";
;
}
;
}
;
}
else {
if(l_moduleSplit == "CUSTOM") {
var t_27;
t_27 = "c-custom-dual-module-" + "" + l_moduleIndex;
frame.set("customClass", t_27, true);
if(frame.topLevel) {
context.setVariable("customClass", t_27);
}
if(frame.topLevel) {
context.addExport("customClass", t_27);
}
;
}
;
}
;
}
;
}
;
}
;
}
if(runtime.contextOrFrameLookup(context, frame, "customClass")) {
t_15 += "\n            o-column ";
t_15 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "customClass"), env.opts.autoescape);
t_15 += "\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "stackedOnMediumScreen")) {
t_15 += "\n            o-column o-extra-small--12 o-large--";
t_15 += runtime.suppressValue(env.getFilter("trim").call(context, env.getFilter("string").call(context, runtime.contextOrFrameLookup(context, frame, "columnWidth"))), env.opts.autoescape);
t_15 += "\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "stackedOnSmallScreen")) {
t_15 += "\n            o-column o-extra-small--12 o-medium--";
t_15 += runtime.suppressValue(env.getFilter("trim").call(context, env.getFilter("string").call(context, runtime.contextOrFrameLookup(context, frame, "columnWidth"))), env.opts.autoescape);
t_15 += "\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isMobileSlider")) {
t_15 += "\n            o-column o-extra-small--12 o-medium--";
t_15 += runtime.suppressValue(env.getFilter("trim").call(context, env.getFilter("string").call(context, runtime.contextOrFrameLookup(context, frame, "columnWidth"))), env.opts.autoescape);
t_15 += "\n        ";
;
}
else {
t_15 += "\n            o-column o-extra-small--";
t_15 += runtime.suppressValue(env.getFilter("trim").call(context, env.getFilter("string").call(context, runtime.contextOrFrameLookup(context, frame, "columnWidth"))), env.opts.autoescape);
t_15 += "\n        ";
;
}
;
}
;
}
;
}
t_15 += "\n\n        s-dual-module\n\n    ";
;
}
else {
if(l_moduleCount == 3 || runtime.contextOrFrameLookup(context, frame, "isGiveaway")) {
t_15 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "stackedOnSmallScreen") || runtime.contextOrFrameLookup(context, frame, "isMobileSlider")) {
t_15 += "\n            o-column o-extra-small--12 o-medium--4 s-triple-module\n        ";
;
}
else {
t_15 += "\n            o-column o-extra-small--4 s-triple-module\n        ";
;
}
t_15 += "\n    ";
;
}
else {
if(l_moduleCount == 4) {
t_15 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "stackedOnSmallScreen")) {
t_15 += "\n            o-column o-extra-small--12 o-small--6 o-medium--3 s-quad-module\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isMobileSlider")) {
t_15 += "\n            o-column o-extra-small--12 o-medium--3 s-quad-module\n        ";
;
}
else {
t_15 += "\n            o-column o-extra-small--3 s-quad-module\n        ";
;
}
;
}
t_15 += "\n    ";
;
}
else {
if(l_moduleCount == 5) {
t_15 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isMobileSlider")) {
t_15 += "\n            c-contentful-five-module c-contentful-five-module--slider\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "stackedOnSmallScreen")) {
t_15 += "\n            c-contentful-five-module--stacked\n        ";
;
}
else {
t_15 += "\n            c-contentful-five-module\n        ";
;
}
;
}
t_15 += "\n    ";
;
}
else {
if(l_moduleCount == 6) {
t_15 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "stackedOnSmallScreen")) {
t_15 += "\n            o-column o-extra-small--12 o-medium--4 o-large--2 s-six-module\n        ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isMobileSlider")) {
t_15 += "\n            o-column o-extra-small--12 o-large--2 s-six-module\n        ";
;
}
else {
t_15 += "\n            o-column o-extra-small--2 s-six-module\n        ";
;
}
;
}
t_15 += "\n    ";
;
}
else {
t_15 += "\n        o-column o-extra-small--12 s-single-module\n    ";
;
}
;
}
;
}
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_15);
});
context.addExport("calculateModuleSplit");
context.setVariable("calculateModuleSplit", macro_t_14);
output += "\n\n";
var macro_t_28 = runtime.makeMacro(
["contentfulEntry"], 
[], 
function (l_contentfulEntry, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("contentfulEntry", l_contentfulEntry);
var t_29 = "";var t_30;
t_30 = runtime.memberLookup((runtime.memberLookup((l_contentfulEntry),"fields")),"excludeFromLargeScreen");
frame.set("excludeFromLargeScreen", t_30, true);
if(frame.topLevel) {
context.setVariable("excludeFromLargeScreen", t_30);
}
if(frame.topLevel) {
context.addExport("excludeFromLargeScreen", t_30);
}
var t_31;
t_31 = runtime.memberLookup((runtime.memberLookup((l_contentfulEntry),"fields")),"excludeFromSmallScreen");
frame.set("excludeFromSmallScreen", t_31, true);
if(frame.topLevel) {
context.setVariable("excludeFromSmallScreen", t_31);
}
if(frame.topLevel) {
context.addExport("excludeFromSmallScreen", t_31);
}
if(runtime.contextOrFrameLookup(context, frame, "excludeFromSmallScreen") && runtime.contextOrFrameLookup(context, frame, "excludeFromLargeScreen")) {
t_29 += "\n        ";
var t_32;
t_32 = "u-extra-small--hide";
frame.set("result", t_32, true);
if(frame.topLevel) {
context.setVariable("result", t_32);
}
if(frame.topLevel) {
context.addExport("result", t_32);
}
t_29 += "\n    ";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "excludeFromSmallScreen") && !runtime.contextOrFrameLookup(context, frame, "excludeFromLargeScreen")) {
t_29 += "\n        ";
var t_33;
t_33 = "u-extra-small--hide u-large--show";
frame.set("result", t_33, true);
if(frame.topLevel) {
context.setVariable("result", t_33);
}
if(frame.topLevel) {
context.addExport("result", t_33);
}
t_29 += "\n    ";
;
}
else {
if(!runtime.contextOrFrameLookup(context, frame, "excludeFromSmallScreen") && runtime.contextOrFrameLookup(context, frame, "excludeFromLargeScreen")) {
t_29 += "\n        ";
var t_34;
t_34 = "u-extra-small--show u-large--hide";
frame.set("result", t_34, true);
if(frame.topLevel) {
context.setVariable("result", t_34);
}
if(frame.topLevel) {
context.addExport("result", t_34);
}
t_29 += "\n    ";
;
}
else {
t_29 += "\n        ";
var t_35;
t_35 = "";
frame.set("result", t_35, true);
if(frame.topLevel) {
context.setVariable("result", t_35);
}
if(frame.topLevel) {
context.addExport("result", t_35);
}
t_29 += "\n    ";
;
}
;
}
;
}
t_29 += "\n\n    ";
t_29 += runtime.suppressValue(env.getFilter("trim").call(context, runtime.contextOrFrameLookup(context, frame, "result")), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_29);
});
context.addExport("calculateScreenSize");
context.setVariable("calculateScreenSize", macro_t_28);
output += "\n\n\n";
var macro_t_36 = runtime.makeMacro(
[], 
["moduleEntry", "isLastInLoop", "isSpecialtyShop"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("moduleEntry", kwargs.hasOwnProperty("moduleEntry") ? kwargs["moduleEntry"] : {});
frame.set("isLastInLoop", kwargs.hasOwnProperty("isLastInLoop") ? kwargs["isLastInLoop"] : false);
frame.set("isSpecialtyShop", kwargs.hasOwnProperty("isSpecialtyShop") ? kwargs["isSpecialtyShop"] : false);
var t_37 = "";var t_38;
t_38 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleEntry")),"fields")),"bottomMarginBetweenMobile") || env.getFilter("trim").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleEntry")),"fields")),"bottomMarginMobile"),"u-margin-bottom--large"));
frame.set("bottomMarginBetweenMobile", t_38, true);
if(frame.topLevel) {
context.setVariable("bottomMarginBetweenMobile", t_38);
}
if(frame.topLevel) {
context.addExport("bottomMarginBetweenMobile", t_38);
}
var t_39;
t_39 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleEntry")),"fields")),"bottomMarginLastMobile") || env.getFilter("trim").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleEntry")),"fields")),"bottomMarginMobile"),"u-margin-bottom--large"));
frame.set("bottomMarginLastMobile", t_39, true);
if(frame.topLevel) {
context.setVariable("bottomMarginLastMobile", t_39);
}
if(frame.topLevel) {
context.addExport("bottomMarginLastMobile", t_39);
}
var t_40;
t_40 = env.getFilter("trim").call(context, env.getFilter("default").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "moduleEntry")),"fields")),"bottomMarginWideScreen"),"u-margin-bottom-wide-screen--large"));
frame.set("bottomMarginWideScreen", t_40, true);
if(frame.topLevel) {
context.setVariable("bottomMarginWideScreen", t_40);
}
if(frame.topLevel) {
context.addExport("bottomMarginWideScreen", t_40);
}
var t_41;
t_41 = "u-specialty-shop-bottom-margin";
frame.set("specialtyShopMarginsCTA", t_41, true);
if(frame.topLevel) {
context.setVariable("specialtyShopMarginsCTA", t_41);
}
if(frame.topLevel) {
context.addExport("specialtyShopMarginsCTA", t_41);
}
if(runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop")) {
t_37 += "\n        ";
if(runtime.contextOrFrameLookup(context, frame, "isLastInLoop")) {
t_37 += "\n\n            ";
t_37 += "\n            ";
t_37 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bottomMarginLastMobile") + "" + " ", env.opts.autoescape);
;
}
else {
t_37 += "\n\n            ";
t_37 += "\n            ";
t_37 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "specialtyShopMarginsCTA") + "" + " ", env.opts.autoescape);
;
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "isLastInLoop")) {
t_37 += "\n\n            ";
t_37 += "\n            ";
t_37 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bottomMarginLastMobile") + "" + " ", env.opts.autoescape);
;
}
else {
t_37 += "\n\n            ";
t_37 += "\n            ";
t_37 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bottomMarginBetweenMobile") + "" + " ", env.opts.autoescape);
;
}
;
}
t_37 += "\n\n    ";
t_37 += "\n    ";
t_37 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "bottomMarginWideScreen"), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_37);
});
context.addExport("getBottomMarginClasses");
context.setVariable("getBottomMarginClasses", macro_t_36);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful-module-spacing.j2"] , dependencies)